import { ServerObjectWithUser, Geometry, ShapeType } from './Common';
import { Location } from './Location'

export enum ActivityColor {
  BLUE = '#307af7',
  GREEN = '#38d753',
  PURPLE = '#b037e4',
  RED = '#ef3e3e',
  YELLOW = '#f7ec41',
  ORANGE = '#ff8439',
}

export type ActivityAsset = ServerObjectWithUser & {
  id: string;
  activityId: string;
  deleted: boolean;
  contentType: string;
  location?: Location | null;
  uri: string;
};

export type ActivityComment = ServerObjectWithUser & {
  id: string;
  activityId: string;
  location?: Location | null;
  note: string;
};

export type Activity = ServerObjectWithUser & {
  location?: Location | null;
  field: string;
  color: ActivityColor;
  scoutedAt: string;
  permanent: boolean;
  title: string;
  comments: ActivityComment[];
  assets: ActivityAsset[];
  tags: string[];
  inversedLocation: Location | null;
  geometry?: Geometry;
}

export type EnhancedActivity = Activity & { // v3 activity
  categoryAttributeItems: CategoryResponse[];
  categoryType: CategoryType | null;
  soilSample: boolean;
}

export const isEnhancedActivity = (activity?: Activity | EnhancedActivity):
  activity is EnhancedActivity => !!activity && 'categoryType' in activity;

export type ActivityTag = {
  id: string,
  text: string,
  rank: number,
  attribute: string,
  master: boolean,
  value: string
};

export type EnhancedScoutingPinPayload = {
  id?: string;
  title: string,
  cropDfpUuid?: string;
  categoryType: CategoryType | null;
  categoryAttributeIds: string[];
  comments: { note: string }[],
  field: string,
  permanent: boolean,
  scoutedAt: string,
  soilSample: boolean;
  location: {
    type: ShapeType.POINT,
    coordinates: number[],
  };
  color: ActivityColor,
};

export type CategoryType = 'WEED' | 'NUTRIENT' | 'DISEASE' | 'INSECT' | 'WATER' | 'OTHER'; // Keys that the backend accepts

export type CategoryTypeResponseKeys = Exclude<CategoryType, 'OTHER'>; // Keys coming from backend response

// category attributes coming from v3 endpoint
export type CategoryResponse = {
  id: string;
  categoryType: CategoryTypeResponseKeys;
  levelCode: string;
  nameCode: string;
  order: number;
};

export type CategoryAttribute = {
  attribute: string;
  levels: CategoryAttributeLevel[];
};

export type CategoryAttributeLevel = {
  id: string;
  level: string;
  order: number;
}

export type CategoryAttributeLevelSelected = {
  [categoryAttribute: string]: CategoryAttributeLevel['id']
};
